// * [UTILITY] Dispatches Google Analytics page view beacons on route transitions
// ? Configured with SameSite=None;Secure cookies for Cloudflare Pages production environments
export const trackPageView = (path) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-STRJLDTGXC', {
      page_path: path,
      cookie_domain: window.location.hostname,
      cookie_flags: 'SameSite=None;Secure',
    });
  }
};
